import React from "react"
import { makeStyles } from "@material-ui/core/styles"

import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"

import allProjects from "../../../content/projects/projects.yml"
import { useStaticQuery, graphql } from "gatsby"

// import ProjectList from "./ProjectList"
import AltProjectList from "./AltProjectList"

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    fontWeight: 400,
    margin: theme.spacing(3, 0, 3, 4),
    [theme.breakpoints.down("md")]: {
      marginLeft: 0,
      textAlign: "center",
    },
  },
}))

export default function InteractiveList() {
  const classes = useStyles()

  const data = useStaticQuery(graphql`
    query allProjectsPicsQuery {
      allFile(
        filter: {
          absolutePath: { regex: "/content/images/dbsystem-projects/" }
        }
      ) {
        edges {
          node {
            childImageSharp {
              fixed(height: 150) {
                originalName
                src
                ...GatsbyImageSharpFixed
              }
            }
          }
        }
      }
    }
  `)

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography component="h2" variant="h5" className={classes.title}>
            Current Incubating Projects
          </Typography>
          <AltProjectList
            allProjPics={data.allFile.edges}
            projectList={allProjects}
            status="incubating"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography component="h2" variant="h5" className={classes.title}>
            Current Projects
          </Typography>
          <AltProjectList
            allProjPics={data.allFile.edges}
            projectList={allProjects}
            status="on-going"
          />
          {/* <div className={classes.demo}>
            <ProjectList
              allProjPics={data.allFile.edges}
              projectList={allProjects}
              status="on-going"
            />
          </div> */}
        </Grid>
        <Grid item xs={12}>
          <Typography component="h2" variant="h5" className={classes.title}>
            Past Projects
          </Typography>
          <AltProjectList
            allProjPics={data.allFile.edges}
            projectList={allProjects}
            status="past"
          />
          {/* <div className={classes.demo}>
            <ProjectList
              allProjPics={data.allFile.edges}
              projectList={allProjects}
              status="past"
            />
          </div> */}
        </Grid>
      </Grid>
    </div>
  )
}
